// extracted by mini-css-extract-plugin
module.exports = {"content":"logogridStyle-module--content--BG9NE"};